import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { URL_API } from 'src/app/tools/URL';

@Injectable({
  providedIn: 'root'
})
export class ClassificacaoService {

  constructor(private rest: RestService) { }

  carregarClassificacoesPorAssunto(assunto) {

    return this.rest.post(`${URL_API.PATH_CLASSIFICACAO}/carregarPorAssunto/`, assunto);

  }

}
